require('./edge.modal.controller')
require('./edge.edit.controller')
require('./edge.generate.otu.controller')
require('./edge.otu.controller')
require('./edge.broadcastView.controller')
require('./map-media-players.controller')
require('./edge.share.broadcast.controller')
require('./edge.event.settings.controller')
require('./edge.event.date.filter.controller')
require('./edge.report.date.filter.controller')
require('./edgeEventsController')
require('./edgeReportsController')
require('./eventsDashboardController')
require('./reportsDashboardController')
require('./edgeRecordingsListController')
require('./edgeRecordingsListController.deprecated')
require('./edge.recording.date.filter.controller')
require('./edge.recording.video.controller')
require('./EdgeEventVideosController')
require('./edge.list.controller')
require('./edge.list.depracated.controller')
require('./multiple.broadcast.videos.controller')
require('./multiple.broadcast.videos.depracated.controller')
require('./edge.map.controller')
require('./edge.geofence.controller')
require('./edge.geofence.add.controller')
require('./edge.geofence.details.controller')
require('./edge.qifi.controller')
require('./events.filter.controller')
require('./edgeTrips.controller')
require('./edge.trip.date.filter.controller')
require('./edgeAgressiveReportsController')
require('./edgeSpeedingReportsController')
require('./edgeGeofenceReportsController')
require('./edge.reports.controller')
require('./edgeDangerousDrivingController')
require('./userSettingsController')
require('./organizationSettingsController')
require('./edge.recordings.timeline.controller.deprecated')
require('./edge.recordings.timeline.controller')
require('../health-reports/health-reports.controller')
require('../health-reports/health-reports-list.controller')
require('../health-reports/health-reports-health.controller')
require('../health-reports/health-reports-alarms.controller')
require('../health-reports/health-reports-alarms-notifications.controller')
require('../health-reports/health-reports-health-notifications.controller')
require('../health-reports/health-reports-data-usage.controller')
